import { useQuery } from '@tanstack/react-query'
import { workflowNodeTypesApi } from '@/api/workflowNodeTypes'

const workflowNodeTypesKey = (projectId: string) =>
  ['projects', projectId, 'workflow-node-types'] as const

export function useWorkflowNodeTypes(projectId: string) {
  return useQuery({
    queryKey: workflowNodeTypesKey(projectId),
    queryFn: () => workflowNodeTypesApi.getAll(projectId),
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // Node types rarely change, cache for 5 minutes
  })
}
